module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Flower1-0a13cb026a17dbbfe32bf9892099a146.svg";